import { DashboardDatePreset, type DashboardDateRange } from './model';
import {
  dashboardRangeForPreset,
  normalizeDashboardCustomRange,
} from '@/components/dashboard/dashboardDateRange';

export type DashboardRouteSearch = {
  preset?: string;
  from?: string;
  to?: string;
};

export interface DashboardRouteFilters {
  range: DashboardDateRange;
}

export function dashboardRouteSearchSchema(search: Record<string, unknown>): DashboardRouteSearch {
  return {
    ...(typeof search['preset'] === 'string' ? { preset: search['preset'] } : {}),
    ...(typeof search['from'] === 'string' ? { from: search['from'] } : {}),
    ...(typeof search['to'] === 'string' ? { to: search['to'] } : {}),
  };
}

export function parseDashboardRouteSearch(
  search: DashboardRouteSearch,
  now = new Date(),
): DashboardRouteFilters {
  const preset = readDashboardDatePreset(search.preset);
  const customRange =
    search.from && search.to ? normalizeDashboardCustomRange(search.from, search.to, now) : null;
  const range = preset
    ? dashboardRangeForPreset(preset, now)
    : (customRange ?? dashboardRangeForPreset(DashboardDatePreset.Today, now));
  return { range };
}

export function serializeDashboardRouteFilters(
  filters: DashboardRouteFilters,
  now = new Date(),
): DashboardRouteSearch {
  const defaultRange = dashboardRangeForPreset(DashboardDatePreset.Today, now);
  if (filters.range.preset) {
    return {
      ...(filters.range.preset !== DashboardDatePreset.Today
        ? { preset: filters.range.preset }
        : {}),
    };
  }
  if (
    filters.range.dateFrom === defaultRange.dateFrom &&
    filters.range.dateTo === defaultRange.dateTo
  ) {
    return {};
  }
  return { from: filters.range.dateFrom, to: filters.range.dateTo };
}

export function readDashboardDatePreset(value: string | undefined) {
  return Object.values(DashboardDatePreset).find((preset) => preset === value);
}
